import { useRef, useState } from 'react';
import _get from 'lodash/get';
import { Attachment, FormAnswerMediaFilterInputObject } from 'graphql-common';
import { useTaskTimelineFormAnswerMediaQuery } from '@lib/graphql-common';
import { DEFAULT_LIST_PARAMS, GetUrlParams, ListParams } from '@lib/enums/urls';

export default function useTaskCompletionsMediaData({
  groupKey,
  formAnswerFilters,
  skip,
}: {
  groupKey: string | null | undefined;
  formAnswerFilters: FormAnswerMediaFilterInputObject[];
  skip: boolean;
}) {
  const [paginationParams, setPaginationParams] =
    useState<ListParams>(DEFAULT_LIST_PARAMS);

  // Media has its own pagination, separate from the completions table's —
  // reset it (during render) whenever the modal shows a different recurring
  // check.
  const prevGroupKeyRef = useRef(groupKey);
  if (prevGroupKeyRef.current !== groupKey) {
    prevGroupKeyRef.current = groupKey;
    if (groupKey) setPaginationParams(DEFAULT_LIST_PARAMS);
  }

  const page = Number(_get(paginationParams, GetUrlParams.Page, 1));
  const perPageParam = _get(paginationParams, GetUrlParams.PerPage);
  const limit = perPageParam ? Number(perPageParam) : undefined;

  const { data, previousData, loading, error } =
    useTaskTimelineFormAnswerMediaQuery({
      variables: {
        groupKey: groupKey || '',
        formAnswerFilters,
        page,
        limit,
      },
      skip: skip || !groupKey,
      fetchPolicy: 'network-only',
    });

  const queryData = data || previousData;
  const collection = _get(queryData, 'data.collection', []) as Attachment[];
  const totalCount = _get(queryData, 'data.metadata.totalCount', 0);
  const firstLoading = loading && queryData === undefined;

  return {
    collection,
    error,
    firstLoading,
    loading,
    paginationParams,
    setPaginationParams,
    totalCount,
  };
}
